/** Authored trade intro (not the short catalog description). */
export const tradeIntroText = trade =>
  (
    trade?.intro ||
    trade?.trade_intro ||
    trade?.trade_description ||
    trade?.description ||
    ''
  ).trim();

export const introParagraphs = text =>
  String(text || '')
    .split(/\n+/)
    .map(p => p.trim())
    .filter(Boolean);

const normalizeLine = entry => {
  if (!entry) return null;
  if (typeof entry === 'string') {
    const text = entry.trim();
    return text ? { text, children: [] } : null;
  }
  const text = String(entry.text || entry.line || entry.label || '').trim();
  if (!text) return null;
  const nested = entry.lines || entry.children || entry.sub_lines || [];
  const children = (Array.isArray(nested) ? nested : [])
    .map(child => {
      if (typeof child === 'string') {
        const t = child.trim();
        return t ? { text: t } : null;
      }
      const t = String(child?.text || child?.line || '').trim();
      return t ? { text: t } : null;
    })
    .filter(Boolean);
  return { text, children };
};

/**
 * Trade-level authored exclusions: { note, lines: [{ text, children }] }.
 * Returns null when there is nothing to render (no empty shell).
 */
export const normalizeTradeExclusions = trade => {
  const raw = trade?.exclusions;
  if (!raw) return null;

  if (Array.isArray(raw)) {
    const lines = raw.map(normalizeLine).filter(Boolean);
    return lines.length ? { note: '', lines } : null;
  }

  if (typeof raw === 'string') {
    const text = raw.trim();
    return text ? { note: '', lines: [{ text, children: [] }] } : null;
  }

  const note = String(raw.note || raw.account_note || '').trim();
  const lines = (raw.lines || raw.items || []).map(normalizeLine).filter(Boolean);
  return lines.length ? { note, lines } : null;
};
